import { useEffect, useRef, useState } from "react";
import { useUIDSeed } from "react-uid";
import styled from "@emotion/styled";
// eslint-disable-next-line import/no-extraneous-dependencies
import { useRouter } from "next/router";
import PropTypes from "prop-types";

import { md, useBreakpoints } from "@hmn/coolinarika-web-core/hooks";

import { withErrorBoundary } from "../../../../ErrorBoundary";
import { Link } from "../../../../Link";
import styles from "./Tabs.style";

const TabsStyled = styled.div((props) => ({ ...styles(props) }));

const Tabs = ({ className, tabs, ...rest }) => {
    const uid = useUIDSeed();
    const router = useRouter();
    const navRef = useRef(null);
    const [sticky, setSticky] = useState(false);
    const [isMediumUp] = useBreakpoints(md);

    const handleScroll = () => {
        if (navRef.current) {
            const currentNavTopPosition = navRef.current.getBoundingClientRect().top;

            setSticky(isMediumUp ? false : currentNavTopPosition <= 0);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, [isMediumUp]);

    if (!tabs && !!tabs.length) {
        return null;
    }

    return (
        <TabsStyled className={className} sticky={sticky} ref={navRef} {...rest}>
            <nav className="Nav">
                <ul className="List">
                    {tabs.map((tab, index) => (
                        <li key={uid(tab?.id) || index}>
                            <Link
                                href={tab?.href}
                                as={tab?.as}
                                title={tab?.title}
                                className={tab?.href === router?.pathname ? "is-active" : undefined}
                            >
                                {tab?.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
        </TabsStyled>
    );
};

Tabs.propTypes = {
    className: PropTypes.string,
    tabs: PropTypes.arrayOf(PropTypes.object),
};

Tabs.defaultProps = {
    className: undefined,
    tabs: undefined,
};

export default withErrorBoundary(Tabs);
